import { render, staticRenderFns } from "./postComment.vue?vue&type=template&id=e20146b8"
import script from "./postComment.vue?vue&type=script&lang=js"
export * from "./postComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports